import { z } from 'zod';
import { serviceAccessTemplateCodeSchema, SERVICE_ACCESS_TEMPLATE_CODES } from './ServiceAccessTemplateCode.js';
import { SectionsSchema } from './ServiceSections.js';

//--------------------------------
// Service Access Object Schema
//--------------------------------
const serviceAccessObjectSchema = z.object({
    required: z.array(SectionsSchema),
    optional: z.array(SectionsSchema),
    template: serviceAccessTemplateCodeSchema.optional(),
});
const defaultServiceAccessObject = {
    required: [],
    optional: [],
    template: SERVICE_ACCESS_TEMPLATE_CODES.DEFAULT,
};

export { defaultServiceAccessObject, serviceAccessObjectSchema };
//# sourceMappingURL=serviceAccess.js.map
